/**
 * jQuery Autocompletion Library
 */
(function( $ ){
   /**
    * TODO: Still need to organize and comment this, but tight on time
    */

   /**
    * Prevent the selection of a jQuery element (or list of elements)
    * @param jEl
    */
   function makeUnselectable(jEl) {
      jEl.each(function(i, el) {
         if (typeof(el) == 'string')
            el = document.getElementById(el);

         if (el) {
            el.onselectstart = function() { return false; };
            el.style.MozUserSelect = "none";
            el.style.KhtmlUserSelect = "none";
            el.unselectable = "on";
         }
      });
   }

   var methods = {
      init: function(options) {
         return this.each(function(){
            var jThis = $(this),
               data = jThis.data('autocomplete'),
               settings = {
                  onKeyDown: function() {
                     // Required: A function to call when keys are pressed
                  },

                  // Required: A class to set for the container
                  containerClass: '',
                  maxItems: null
               };

            // If the plugin hasn't been initialized yet
            if (!data) {
               // Initialize the plugin!
               $.extend(settings, options);
               data = {
                  target : jThis,
                  options: options
               };
               jThis.data('autocomplete', data);

               var jAjaxDropdown = $('<div class="ajaxDropdown" />'),
                  jContainer = $('<div class="autocompleteContainer"/>'),
                  jDropdownContainer = $('<div class="dropdownContainer"/>');

               data.ajaxDropdown = jAjaxDropdown;

               // The "foreground" is what the user types into
               var jForeground = $('<input autocomplete="off" id="userForegroundInput" type="text" />'),

                  // The "background" is the gray autocompletion text
                  jBackground = $('<input autocomplete="off" id="userBackgroundInput" type="text" />'),

               oCss = {
                  position: 'absolute',
                  background: 'transparent',
                  borderColor: 'transparent'
               };

               data.foreground = jForeground;
               data.background = jBackground;

               var strBaseName = jThis.attr('name') || jThis.attr('id');
               jForeground.attr('name', strBaseName + '_AUTOCOMPLETE_FOREGROUND');
               jBackground.attr('name', strBaseName + '_AUTOCOMPLETE_BACKGROUND');

               jForeground.css(oCss).css({ color: '#000000' }).addClass('foreground').val(jThis.val());
               jBackground.css(oCss).css({ color: '#757575' }).addClass('background');
               jContainer.addClass(options.containerClass);

               jThis.css({ color: 'transparent' });

               var userForegroundLabel = '<label for="userForegroundInput" class="sr-only" aria-hidden="true">User Foreground Input</label>';
               var userBackgroundLabel = '<label for="userBackgroundInput" class="sr-only" aria-hidden="true">User Background Input</label>';

               jThis.after(jContainer);
               jDropdownContainer.append(jAjaxDropdown);
               jContainer.append(jThis).append(jBackground).append(userBackgroundLabel).append(jForeground).append(userForegroundLabel).append(jDropdownContainer);
               jThis.hide();

               jThis.focus(function() {jForeground.focus();});
               jBackground.focus(function(){jForeground.focus();});

               jThis.get(0).focus = function() {
                  jForeground.focus();
               };

               jAjaxDropdown.css({
                  opacity: 0
               });

               function showDropdown() {
                  jThis.autocomplete('show');
               }

               function hideDropdown() {
                  data.background.hide();
                  setTimeout(function() {
                     jThis.autocomplete('hide');
                  }, 100);
               }

               function doKey(event) {
                  var strText = jForeground.val(),
                     strHiddenText = jThis.val(),
                     strBackgroundText = jBackground.val(),
                     bIsDirty = (data.lastFilter != strText);

                  if (
                     // The background text is (somehow) out of sync
                     (data.background.val().indexOf(strText) == -1) ||

                     // There is no text at all...
                     (strText == '')
                  ) {
                     data.background.val('');
                  }

                  jThis.val(strText);

                  settings.onKeyDown(strText, bIsDirty);
               }

               jForeground.focus(doKey).blur(hideDropdown).blur(function() {
                  jThis.val(data.foreground.val());
               });

               function setValue(strValue) {
                  jForeground.val(strValue);
               }

               function selectNextResult() {
                  var jSelected = jAjaxDropdown.find('.selected'),
                     jToBeSelected = jSelected.next('.result');

                  if (jToBeSelected.length == 0) {
                     jToBeSelected = jAjaxDropdown.find('.result:first');
                  }

                  jSelected.removeClass('selected');
                  jToBeSelected.addClass('selected');

                  var strFullItem = jToBeSelected.data('fullItemValue');
                  data.foreground.val(strFullItem);
                  data.background.val(strFullItem);
                  data.lastFilter = strFullItem;
               }

               function selectPreviousResult() {
                  var jSelected = jAjaxDropdown.find('.selected'),
                     jToBeSelected = jSelected.prev('.result');

                  if (jToBeSelected.length == 0) {
                     jToBeSelected = jAjaxDropdown.find('.result:last');
                  }

                  jSelected.removeClass('selected');
                  jToBeSelected.addClass('selected');

                  var strFullItem = jToBeSelected.data('fullItemValue');
                  data.foreground.val(strFullItem);
                  data.background.val(strFullItem);
                  data.lastFilter = strFullItem;
               }

               jForeground.onNonKeyboardInitiatedChange(doKey).keyup(doKey).keydown(function(event) {
                  var iKeyCode = event.keyCode,
                     strValue;

                  // ENTER key
                  if (iKeyCode == 13) {
                     strValue = data.foreground.val();
                     jThis.val(strValue);
                     data.foreground.blur();
                     hideDropdown();
                     if (options.onEnter) {
								var jSelected = jAjaxDropdown.find('.selected');
								var metadata = jSelected.data('autocomplete-metadata');
								var onlyOneItem = jAjaxDropdown.find('.result').length === 1;
								var textExactMatch = data.foreground.val() === jSelected.data('fullItemValue');
								var bSelectedSpecificItem = textExactMatch || onlyOneItem;
                        options.onEnter(strValue, metadata, bSelectedSpecificItem);
                     }
                     return true;

                  // ESC key
                  } else if (iKeyCode == 27) {
                     data.foreground.blur();
                     hideDropdown();
                     return false;
                  // UP arrow
                  } else if (iKeyCode == 38) {
                     selectPreviousResult();
                     return false;
                  // RIGHT arrow or TAB key
                  } else if (iKeyCode == 39 || iKeyCode == 9) {
                     var strBackgroundText = data.background.val();

                     // If there is autocomplete text
                     if (strBackgroundText) {
                        // Set the current value to it
                        data.foreground.val(strBackgroundText);
                        jThis.val(strBackgroundText);
                     }
                  // DOWN arrow
                  } else if (iKeyCode == 40) {
                     selectNextResult();
                     return false;
                  }
               });
            }

            $(window).unload(function() {
               jThis.autocomplete('destroy');
            });
         });
      },

      destroy : function() {
         return this.each(function() {
            var jThis = $(this),
               data = jThis.data('autocomplete');

            // Namespacing FTW
            $(window).unbind('.autocomplete');
            data.foreground.remove();
            data.background.remove();
            jThis.removeData('autocomplete');
         })
      },
      reposition : function( ) {
      },
      show : function( ) {
         var jThis = $(this),
            data = jThis.data('autocomplete'),
            jAjaxDropdown = data.ajaxDropdown;

         if (data.shown) return;
         data.shown = true;

         jAjaxDropdown.stop().css({
            display: 'block'
         });

         data.background.show();

         // The position does not show up correctly
         // until AFTER the display is set to 'block'
         var iTop = jAjaxDropdown.position().top,
            iTotalTime = 600;

         jAjaxDropdown.animate({
            opacity: 1,
            top: 5
         }, {
            duration: iTotalTime,
            complete: function() {
               jAjaxDropdown.css({
                  zoom: 1
               });
            }
         });
      },
      hide : function( ) {
         var jThis = $(this),
            data = jThis.data('autocomplete'),
            jAjaxDropdown = data.ajaxDropdown;

         data.shown = false;

         jAjaxDropdown.stop().animate({
            opacity: 0,
            top: -5
         }, {
            easing: 'easeOutQuad',
            duration: 300,
            complete: function() {
               jAjaxDropdown.hide();
            }
         });
      },
      update : function(strTitle, strFilter, aItems, aMetadata) {
         var jThis = $(this),
            data = jThis.data('autocomplete'),
            jAjaxDropdown = data.ajaxDropdown;

         jAjaxDropdown.empty();
         data.lastFilter = strFilter;

         if (strTitle != '') {
            jAjaxDropdown.append($('<div />', {
               text: strTitle,
               'class': 'title' + ((aItems.length > 0) ? ' withItems' : '')
            }));
         }

         // By default, select the first item
         // Autocomplete to the selected item

         $.each(aItems, function(i, strItem) {
            if (data.options.maxItems) {
               if (i >= data.options.maxItems) {
                  return false;
               }
            }

            var jResult = $('<div class="result" />'),
               jBold = $('<span />', {
                  text: strItem.substr(0, strFilter.length),
                  'class': 'bolded'
               }),
               strRemainder = strItem.substr(strFilter.length),
               elRemainder = document.createTextNode(strRemainder),
               bResultsMatch = false,
               onItemHover;

            if (strFilter.toLowerCase() == strItem.substr(0, strFilter.length).toLowerCase()) {
               jResult.append(jBold);
               jResult.append(elRemainder);
               bResultsMatch = true;

               var onItemHover = function() {
                  data.background.val(strFilter + strRemainder);
               }
            } else {
               jResult.text(strItem);
               bResultsMatch = false;

               var onItemHover = function() {
                  // Results do not mach foreground...
               }
            }
            jAjaxDropdown.append(jResult);

            jResult.data('itemValue', strFilter + strRemainder);
            jResult.data('fullItemValue', strItem);

				if (aMetadata && aMetadata[i]) {
					jResult.data('autocomplete-metadata', aMetadata[i]);
				}

            jResult.click(function() {
               if (bResultsMatch) {
                  var strValue = strFilter + strRemainder;
               } else {
                  var strValue = strItem;
               }

               data.foreground.val(strValue);
               data.background.val(strValue);
               jThis.val(strValue);

               if (data.options.onClick) {
                  var metadata = jResult.data('autocomplete-metadata');
                  data.options.onClick(strItem, metadata, true);
               }

               jAjaxDropdown.hide();
            }).hover(onItemHover, function() {});
         });

			data.background.val('');

         var jResults = jAjaxDropdown.find('.result');
         jResults.mousedown(function() {
            $(this).addClass('mousedown');
         }).mouseup(function() {
            $(this).removeClass('mousedown');
         });

         jResults.hover(function() {
            jResults.removeClass('selected');
            var jResult = $(this);
            jResult.addClass('selected');
         }, function() {
            $(this).removeClass('selected');
         });

         makeUnselectable(jResults);

         return jThis;
      },
      val : function(strVal) {
         var jThis = $(this),
            data = jThis.data('autocomplete');

         if (strVal == undefined) {
            return data.foreground.val();
         } else {
            data.foreground.val(strVal);
            data.background.val(strVal);
            jThis.val(strVal);
            return jThis;
         }
      }
   };

   $.fn.autocomplete = function(method) {
      if (methods[method]) {
         return methods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
      } else if (typeof method === 'object' || ! method) {
         return methods.init.apply( this, arguments );
      } else {
         $.error( 'Method ' +  method + ' does not exist on jQuery.autocomplete' );
      }
   };
})( jQuery );

/**
 * Extension good for:
 * Cross-browser detection for "paste" when the user does rightclick->paste
 */
(function($) {
   $.fn.onNonKeyboardInitiatedChange = function(fn) {
      var jEl = $(this);

      return jEl.each(function() {
         var strVal = jEl.val();

         jEl.bind('keydown keyup change', function() {
            strVal = jEl.val();
         });

         setInterval(function() {
            var strNewVal = jEl.val();
            if (strNewVal != strVal) {
               strVal = strNewVal;
               fn();
            }
         }, 500);
      });
   };
})(jQuery);
